import { Box } from '@wix/design-system';
import React from 'react';
import s from './CardLayout.module.scss';
import cn from 'classnames';
export const CardLayout = _ref => {
  let {
    children,
    borderless
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "8px",
    padding: borderless ? undefined : 'SP2',
    className: cn(s.container, {
      [s.containerBorderless]: borderless
    })
  }, children);
};
//# sourceMappingURL=CardLayout.js.map